module.exports = __webpack_public_path__ + "static/media/grinning-face-with-sweat-svgrepo-com.a654c0fc.svg";